import React, { useEffect, memo } from 'react';
import { connect } from 'react-redux';
import { changeFilters, getFilters } from '../../actions/leadsReport';
import Checkbox from '../helpers/Checkbox';
import { Spinner } from '../helpers/Spinner';

/**
 * Leads report filters component.
 *
 * @param {object} props Props.
 * @param {boolean} props.isFiltersFetching Show spinner icon when set to true.
 * @param {Immutable.List} props.modules Available filters.
 * @param {Function} props.getFilters Method for getting available filters for getting leads.
 * @param {Function} props.changeFilters Method for changing filters for getting leads.
 */
const FiltersComponent = props => {
  const { isFiltersFetching, modules, changeFilters, getFilters } = props;

  useEffect(() => {
    getFilters();
  }, []);

  const spinner = isFiltersFetching ? <Spinner className="spinner--block" /> : null;

  const content = modules.map((module, moduleIndex) => {
    const moduleId = module.get('moduleId');
    const moduleName = module.get('moduleName');
    const isCheckedModule = module.get('isChecked');
    const users = module.get('users').map((user, userIndex) => {
      const userId = user.get('userId');
      const userName = user.get('userName');
      const isCheckedUser = user.get('isChecked');

      return (
        <Checkbox
          key={userId}
          capitalizeLabel={false}
          defaultChecked={isCheckedUser}
          label={userName}
          name="user"
          onChange={event => changeFilters(event.target, moduleIndex, userIndex)}
          value={userId}
        />
      );
    });

    return (
      <div key={moduleId}>
        <Checkbox
          capitalizeLabel={false}
          defaultChecked={isCheckedModule}
          label={moduleName}
          name="module"
          onChange={event => changeFilters(event.target, moduleIndex)}
          value={moduleId}
        />
        {isCheckedModule && (
          <div className="ml20 mb10">
            <span className="field-label mt4">Users</span>
            {users}
          </div>
        )}
      </div>
    );
  });

  return (
    <>
      <p className="form-section-label">Filters</p>
      <span className="field-label">Modules</span>
      {spinner}
      {isFiltersFetching === false && <div>{content}</div>}
    </>
  );
};

const mapStateToProps = state => ({
  isFiltersFetching: state.leadsReport.get('fetchingAvailableFilters'),
  modules: state.leadsReport.getIn(['filters', 'modules']),
});

const mapActionToProps = {
  getFilters,
  changeFilters,
};

const Filters = connect(mapStateToProps, mapActionToProps)(memo(FiltersComponent));

export { Filters };
